import 'react-notifications/lib/notifications.css'
import React, { Component } from 'react'
import { NotificationContainer, NotificationManager } from 'react-notifications'
import { useParams } from 'react-router-dom'
import { FaUserEdit, FaEnvelope, FaLock, FaUser, FaSave } from "react-icons/fa"
import AdminLayout from "../../../components/AdminLayout"

//Components
import AdminService from "../../../services/admin_services"

export function withRouter(Children) {
    return (props) => {
        const match = { params: useParams() };
        return <Children {...props} match={match} />
    }
}

class AdminUpdateAccount extends Component {
    constructor(props) {
        super(props)
        this.state = {
            processing: false,
            success: false,
            fileData: null,
            fileSize: 0,
            fileExtension: null,
            levels: [],
            admin_uuid: null,
            firstname: null,
            lastname: null,
            email_address: null,
            password: null,
            account: {}
        }
    }

    componentDidMount = async () => {
        const { id } = this.props.match.params
        const accounts = await AdminService.getAdmins()
        for (let acc of accounts) {
            if (acc.admin_uuid === id)
                this.setState({ account: acc, admin_uuid: id })
        }
    }

    update = async () => {
        try {
            this.setState({ processing: true })
            const data = await AdminService.updateAdmin(this.state.email_address, this.state.firstname, this.state.lastname)
            NotificationManager.success(data.message)
            this.setState({ processing: false, success: true, email_address: null, firstname: null, lastname: null })
        } catch (e) {
            this.setState({ processing: false })
            NotificationManager.error(e.response && e.response.data ? e.response.data.message : e.message)
        }
    }

    updatePswd = async () => {
        if (!this.state.password || (this.state.password.length < 8))
            NotificationManager.error('Incorrect format')
        else {
            try {
                this.setState({ processing: true })
                const data = await AdminService.updateAdminPswd(this.state.password)
                NotificationManager.success(data.message)
                this.setState({ processing: false, success: true })
            } catch (e) {
                this.setState({ processing: false })
                NotificationManager.error(e.response && e.response.data ? e.response.data.message : e.message)
            }
        }
    }

    render() {
        return (
            <>
                <AdminLayout 
                    title="Update Admin Account"
                    breadcrumbs={[
                        { label: 'Accounts', path: '/admin/accounts' },
                        { label: 'Update' }
                    ]}
                >
                    <div className="max-w-2xl mx-auto space-y-6">
                        {/* Account Information Section */}
                        <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
                            {/* Header */}
                            <div className="bg-gradient-to-r from-blue-500 to-indigo-600 px-6 py-4">
                                <h3 className="text-xl font-bold text-white flex items-center gap-2">
                                    <FaUserEdit />
                                    Update Account Information
                                </h3>
                                <p className="text-sm text-white/90 mt-1">
                                    Modify account details for {this.state.account.firstname} {this.state.account.lastname}
                                </p>
                            </div>

                            {/* Form */}
                            <div className="p-6 space-y-4">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            <FaUser className="inline mr-1 text-gray-500" />
                                            First Name
                                        </label>
                                        <input 
                                            type="text" 
                                            placeholder="Enter first name"
                                            onChange={(e) => this.setState({ firstname: e.target.value })}
                                            defaultValue={this.state.account.firstname}
                                            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            <FaUser className="inline mr-1 text-gray-500" />
                                            Last Name
                                        </label>
                                        <input 
                                            type="text" 
                                            placeholder="Enter last name"
                                            onChange={(e) => this.setState({ lastname: e.target.value })}
                                            defaultValue={this.state.account.lastname}
                                            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                                        />
                                    </div>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        <FaEnvelope className="inline mr-1 text-gray-500" />
                                        Email Address
                                    </label>
                                    <input 
                                        type="email" 
                                        placeholder="admin@example.com"
                                        onChange={(e) => this.setState({ email_address: e.target.value })}
                                        defaultValue={this.state.account.email_address}
                                        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                                    />
                                </div>

                                <div className="pt-4 flex justify-end">
                                    {this.state.processing ? (
                                        <div className="px-6 py-2.5 bg-gray-100 text-gray-500 rounded-lg flex items-center gap-2">
                                            <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                            Updating...
                                        </div>
                                    ) : (
                                        <button 
                                            onClick={this.update}
                                            className="px-6 py-2.5 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg hover:from-blue-600 hover:to-indigo-700 transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2"
                                        >
                                            <FaSave />
                                            Update Account
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Password Section */}
                        <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
                            {/* Header */}
                            <div className="bg-gradient-to-r from-purple-500 to-pink-600 px-6 py-4">
                                <h3 className="text-xl font-bold text-white flex items-center gap-2">
                                    <FaLock />
                                    Update Password
                                </h3>
                                <p className="text-sm text-white/90 mt-1">
                                    Change the account password for enhanced security
                                </p>
                            </div>

                            {/* Form */}
                            <div className="p-6 space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        <FaLock className="inline mr-1 text-gray-500" />
                                        New Password
                                    </label>
                                    <input 
                                        type="password" 
                                        placeholder="Minimum 8 characters"
                                        onChange={(e) => this.setState({ password: e.target.value })}
                                        value={this.state.password || ''}
                                        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none"
                                    />
                                    <p className="text-xs text-gray-500 mt-1">Password must be at least 8 characters long</p>
                                </div>

                                <div className="pt-4 flex justify-end">
                                    {this.state.processing ? (
                                        <div className="px-6 py-2.5 bg-gray-100 text-gray-500 rounded-lg flex items-center gap-2">
                                            <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                            Updating Password...
                                        </div>
                                    ) : (
                                        <button 
                                            onClick={this.updatePswd}
                                            className="px-6 py-2.5 bg-gradient-to-r from-purple-500 to-pink-600 text-white rounded-lg hover:from-purple-600 hover:to-pink-700 transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2"
                                        >
                                            <FaSave />
                                            Update Password
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </AdminLayout>
                <NotificationContainer />
            </>
        )
    }
}

export default withRouter(AdminUpdateAccount)